/**
 * @fileoverview Agent definition for item-continuity-checker-v2.
 *
 * This agent analyzes a chapter specifically for item/object continuity errors,
 * checking existence, state, location, possession, and clothing consistency.
 *
 * @category narrative.prose.continuity
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'item-continuity-checker-v2',
  kind: 'primitive',
  name: 'Item Continuity Checker',
  description: 'Analyzes chapter content for contradictions with established item states, locations, possession, and existence.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.continuity',
    usedBy: [
      'use-item-continuity-checker-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'chapter-continuity-checker-v2',
      'character-continuity-checker-v2',
    ],
  },
};
